<section class="left">
  <go-logo></go-logo>

  <div class="small-logo hide-screen-md-min hide-screen-sm">
    <img src="https://staticassets.goreact.com/logo-goreact-spot-2022.svg" alt="GoReact"> <span translate="{{titleString}}"></span>
  </div>

  <p class="description" translate="email-and-password_description"></p>

  <img class="left-image" src="https://staticassets.goreact.com/sign-up.png" alt="">

</section>

<section class="right" [formGroup]="form" #content>
  <div class="sign-in-wrapper hide-screen-sm">
    @if (currentRegionLabel) {
      <div class="region-display">
        <span class="region-display-label" translate="region-selector_label"></span>
        <button
          type="button"
          class="region-display-btn btn-none"
          (click)="openRegionSelector()"
          [attr.aria-label]="'region-selector_current-region' | translate : { region: currentRegionLabel }">
          <span>{{ currentRegionLabel }}</span>
        </button>
      </div>
    }
    <span>
      <span translate="sign-up-already-have-an-account"></span>
      <button type="button" class="login-link goreact-btn tertiary-btn color-red" (click)="navigateToLogin()" translate="log-in"></button>
    </span>
  </div>

  <h1 class="hide-screen-sm" translate="{{titleString}}" [attr.aria-label]="'sign-up-level-1-heading-aria-label' | translate"></h1>
  <div class="small-logo hide-tablet-min">
    <img src="https://staticassets.goreact.com/logo-goreact-spot-2022.svg" alt="GoReact"> <span translate="{{titleString}}"></span>
  </div>

  <div goRequiredFieldsNote>
    <div class="name-fields">
      @if (form.controls.firstName) {
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{'sign-up-form-label-first-name' | translate}}</mat-label>
          <input type="text" matInput formControlName="firstName" maxlength="40" data-cy="guest-signup-form-first-name" class="fullstory-ignore" />
          @if (form.controls.firstName.hasError('required')) {
            <mat-error>{{'sign-up-form-validation-first-name-required' | translate}}</mat-error>
          }
          @if (form.controls.firstName.hasError('maxlength')) {
            <mat-error>{{'sign-up-form-validation-first-name-maxlength' | translate}}</mat-error>
          }
        </mat-form-field>
      }

      @if (form.controls.lastName) {
        <mat-form-field appearance="outline" class="last-name-field" subscriptSizing="dynamic">
          <mat-label>{{'sign-up-form-label-last_name' | translate}}</mat-label>
          <input type="text" matInput formControlName="lastName" maxlength="40" data-cy="guest-signup-form-last-name" class="fullstory-ignore" />
          @if (form.controls.lastName.hasError('required')) {
            <mat-error>{{'sign-up-form-validation-last-name-required' | translate}}</mat-error>
          }
          @if (form.controls.lastName.hasError('maxlength')) {
            <mat-error>{{'sign-up-form-validation-last-name-maxlength' | translate}}</mat-error>
          }
        </mat-form-field>
      }
    </div>
  </div>

  <mat-form-field appearance="outline" class="email-form-field-container" subscriptSizing="dynamic">
    <mat-label>{{'common_email' | translate}}</mat-label>
    <input type="email" matInput formControlName="email" maxlength="100" data-cy="ins-signup-form-email" class="fullstory-ignore" [readonly]="lockEmailField"/>
    @if (mode !== SIGNUPMODES.GUEST_REVIEW) {
      <button
        mat-icon-button
        matIconSuffix
        [matTooltip]="'sign-up-recommend-work-email' | translate">
        <mat-icon
          class="ficon-app-help-circle-outline">
        </mat-icon>
      </button>
    }
    @if (form.controls.email.hasError('email')) {
      <mat-error data-cy="ins-signup-form-email-invalid">{{'sign-up-form-validation-email-invalid' | translate}}</mat-error>
    }
    @if (form.controls.email.hasError('required')) {
      <mat-error>{{'sign-up-form-validation-email-required' | translate}}</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" class="password-form-field-container" subscriptSizing="dynamic" goPasswordVisibilityToggle goPasswordRequirements>
    <mat-label>{{'sign-up-form-label-password' | translate}}</mat-label>
    <input type="password" matInput formControlName="password" data-cy="ins-signup-form-password" class="fullstory-ignore password-form-field" />
    <button
      mat-icon-button
      matIconSuffix
      [matTooltip]="'sign-up-password-rules' | translate">
      <mat-icon
        class="ficon-app-help-circle-outline">
      </mat-icon>
    </button>
    @if (form.controls.password.invalid) {
      <mat-error data-cy="ins-signup-form-password-invalid">{{'common_password_error-password-requirements' | translate}}</mat-error>
    }
  </mat-form-field>
	<span class="terms-and-privacy" [innerHTML]="
		'terms-privacy-with-links-signup' | translate:{
			terms: 'https://get.goreact.com/terms',
			privacy: 'https://get.goreact.com/privacy'
		}">
  </span>

  @if (httpError) {
    <div role="alert" class="http-error">{{httpError}}</div>
  }

  <div class="signup-options-wrapper">
    <button
      class="submit-btn primary-btn"
      data-cy="ins-signup-form-submit-btn"
      (click)="submit()"
      [disabled]="loading"
      [focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}">{{(loading ? 'common_please-wait_loading' : 'sign-up') | translate}}
    </button>

    <sso-provider-button (onLoginWithSso)="signupWithSso($event)"></sso-provider-button>
  </div>

  <div class="sign-in-wrapper hide-tablet-min">
    @if (currentRegionLabel) {
      <div class="region-display">
        <span class="region-display-label" translate="region-selector_label"></span>
        <button
          type="button"
          class="region-display-btn btn-none"
          (click)="openRegionSelector()"
          [attr.aria-label]="'region-selector_current-region' | translate : { region: currentRegionLabel }">
          <span>{{ currentRegionLabel }}</span>
        </button>
      </div>
    }
    <span>
      <span translate="sign-up-already-have-an-account"></span>
      <button type="button" class="login-link goreact-btn tertiary-btn color-red" (click)="navigateToLogin()" translate="log-in"></button>
    </span>
  </div>

  @if (mode !== SIGNUPMODES.GUEST_REVIEW) {
    <div class="user-type-info">
      <div [innerHTML]="'email-and-password_student-and-student-teachers' | translate"></div>
      <span>
        <button
          mat-icon-button
          [matTooltip]="'sign-up-student-student-teachers' | translate"
          matIconSuffix>
          <mat-icon
            class="ficon-app-help-circle-outline"
          ></mat-icon>
        </button>
      </span>
    </div>
  }
</section>
